import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer} from 'recharts';
import { money } from 'utils/helpers';

const ProfitChart = (props) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={props.data} margin={{ top: 20, right: 30, left: 70, bottom: 5 }}>
        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
        <XAxis dataKey="month" />
        <YAxis tickMargin={10} tickFormatter={(value) => money(value)} />
        <Tooltip formatter={(value) => [`Rp ${money(String(Math.floor(value)))}`, 'Profit']} />
        <Line type="monotone" dataKey="profit" stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ProfitChart;
